export const constructStrRep = (obj) => {
  return obj.str_representation || "Felanmälnings-faktura";
};

export const detailUrl = ({ id }) => {
  return `/report-errands/detail/${id}/invoicing`;
};

export const overviewUrl = () => ``;
